// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ToggleButton_wrapper__3vs0h","expanded":"ToggleButton_expanded__2B6Eq","inverted":"ToggleButton_inverted__13X6i","bar":"ToggleButton_bar__XZHHh"};